module.exports = __webpack_public_path__ + "img/ic-next-active.3280bfca.svg";